module.exports = __webpack_public_path__ + "img/zoom_in.2ecb60ca.svg";